export const paymentModes = {
  deposit: 'deposit',
  withdrawal: 'withdrawal'
}

export const withdrawalSteps = {
  create: 'create',
  submit: 'submit'
}

export const qrCodeSize = 256

export const cryptoChannelDefaultData = {
  alternatives: [],
  depositAddress: '',
  destinationTag: '',
  bvnkHostedPageUrl: ''
}

export const withdrawFormFields = {
  address: 'address',
  amountInTargetCurrency: 'amountInTargetCurrency',
  currency: 'currency',
  destinationTag: 'destinationTag',
  protocol: 'protocol',
  targetCurrency: 'targetCurrency',
  cryptoAmount: 'cryptoAmount'
}

export const depositFormFields = {
  coinsAmount: 'coinsAmount',
  cryptoAmount: 'cryptoAmount',
  cryptoCurrencyCode: 'cryptoCurrencyCode',
  address: 'address',
  destinationTag: 'destinationTag'
}

export const formFieldPlaceholders = {
  crypto: '0.0000',
  numeric: '0.00'
}

export const formFieldDefaultConfig = {
  maxDecimals: 4,
  autoFillDecimals: true
}

export const withdrawalDraftDefaultData = {
  uuid: '',
  dateCreated: 0,
  expiryDate: 0,
  reference: '',
  displayCurrency: {
    currency: '',
    amount: 0
  },
  walletCurrency: {
    currency: '',
    amount: 0
  },
  paidCurrency: {
    currency: '',
    amount: 0
  },
  feeCurrency: {
    currency: '',
    amount: 0
  },
  networkFeeCurrency: {
    currency: '',
    amount: 0
  },
  displayRate: {
    base: '',
    counter: '',
    rate: 0
  },
  exchangeRate: {
    base: '',
    counter: '',
    rate: 0
  },
  quoteExpiryDate: 0,
  acceptanceExpiryDate: 0
}

export const withdrawalResponseDefaultData = {
  amount: null,
  currency: ''
}
